module.exports = __webpack_public_path__ + "static/img/page23.3db3e02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page23.jpg
// module id = MzEn
// module chunks = 0